export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/piano.0db1874.svg";